import { env } from "@core/config/env";
import { getStoredToken, removeToken } from "@core/index";
import { useMutation } from "@tanstack/react-query";

// Auth utility functions
export const handleGoogleLogin = async () => {
  window.location.href = `${env.apiBaseUrl}/auth/google`;
};

export const useSignOutUser = () => {
  return useMutation({
    mutationFn: async () => {
      const token = getStoredToken();

      const response = await fetch(`${env.apiBaseUrl}/auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Logout failed");
      }

      return response.json();
    },
    onSuccess: () => {
      clearTokenAndRedirect();
    },
    onError: (error: Error) => {
      console.error("Logout error:", error.message);
      clearTokenAndRedirect();
    },
  });
};

const clearTokenAndRedirect = () => {
  removeToken();
  window.location.href = "/login";
};
